import React from 'react'
import '../../styles/style-ind.css'
const SectionTwo = () => {

    // const indian_brand = [
    //     {
    //         icon: "assets/images/kwikpricing/foxtale.png",
    //         width: "90",
    //     },
    //     {
    //         icon: "assets/images/kwikpricing/levis.png",
    //         width: "100",
    //     },
    //     {
    //         icon: "assets/images/kwikpricing/adil.png",
    //         width: "114",
    //     },
    //     {
    //         icon: "assets/images/kwikpricing/caffeine.png",
    //         width: "70",
    //     },
    //     {
    //         icon: "assets/images/kwikpricing/bsc.png",
    //         width: "60",
    //     },
    //     {
    //         icon: "assets/images/kwikpricing/ace.png",
    //         width: "130",
    //     },
    // ];


    return (
        <div className='price-inter-two'>

        </div>  
    )
}

export default SectionTwo